module.exports = __webpack_public_path__ + "static/media/esc.57fe329a.svg";